export var CLINIC_SETUP_NAME_REGEX = /^[A-Za-z0-9.']+(?:[A-Za-z0-9.'\s]+[A-Za-z0-9.']+)*$/;
export var CLINIC_SETUP_LINK_REGEX = /^[A-Za-z0-9]+$/;
